export default {
  //   mã GD momo=momo 交易码
  // TK nhận=收款账号
  // TK gửi=转账账号
  // Tên TK=账号名称
  // Gía trị=金额
  // Nội dung=描述
  // Trạng thái=状态
  // Thời gian nhận tiền=时间收款
  // Thời gian quét=时间拉记录

  tranid: 'momo 交易码',
  recordId: '收款账号',
  partnerId: '付款账号',
  user: '转账账号',
  partnerName: '账号名称',
  amount: '金额',
  desc: '描述',
  status: '状态',
  acktime: '时间收款',
  createTime: '时间拉记录',
  merchantOrderNo: '商户订单号',
  systemOrderNo: '系统订单号',
  comment: '备注',
  no: "设备编码"
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/momoLogs.js